import script from "./JaHome.vue?vue&type=script&setup=true&lang=js"
export * from "./JaHome.vue?vue&type=script&setup=true&lang=js"

import "./JaHome.vue?vue&type=style&index=0&id=f9bde956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9bde956"]])

export default __exports__